import type { FunctionComponent } from 'react';
import { ObservedElement } from '../../../../../app-kit/components/ObservedElement/ObservedElement';
import { PropertiesCollectionBrick } from '../../../../../app-kit/components/PropertiesCollectionBrick/PropertiesCollectionBrick';
import { usePaginatedSchoolPageBySlugTabContentQuery } from './helpers/usePaginatedSchoolPageBySlugTabContentQuery';

export const SchoolPaginatedPropertiesBrickWithData: FunctionComponent = () => {
  const { properties, fetching, fetchMore } = usePaginatedSchoolPageBySlugTabContentQuery();

  if (!properties) return null;

  return (
    <>
      <PropertiesCollectionBrick
        properties={properties.map(
          ({ pathV2, clickThroughTracking, priceV2, address, image, badgeV2, features }) => ({
            path: pathV2,
            clickThroughSource: clickThroughTracking,
            title: priceV2,
            titleExtra: null,
            subtitle: address,
            image,
            badge: badgeV2,
            features: features?.map((feature) => ({ ...feature, iconName: feature.iconNameV2 })),
          }),
        )}
      />
      {!fetching && <ObservedElement rootMargin="200px" onIntersect={fetchMore} />}
    </>
  );
};
